module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "canvas",
    on: {
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove,
      "mouseup": _vm.mouseUp,
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c901a51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-esign/src/index.vue
// module id = 503
// module chunks = 1